// Importamos primero dsys para obtener todas sus variables y estilos
import "@a365/dsys";
// Luego importamos nuestros estilos encapsulados
import "./assets/css/footerv2.min.css";

import React, { useEffect, useState } from "react";
import Footer from "./views/footer";
import { WRAPPER_CLASS, APP_CLASS } from "./utils/cssConfig";

export default function Root(props) {
  const [visibility, setVisibility] = useState(false);

  useEffect(() => {
    function updateVisibility() {
      const app = window.location.pathname.split("/")[2];
      const excluded_apps = [
        "assist-pay",
        "productos",
        "products",
        "checkout",
        "mi-voucher",
        "mi-voucher2",
        "afiliados",
        "preguntas-frecuentes",
        "cancellation-service",
        "cancel-subscription",
        "cgp",
      ];

      const state = !excluded_apps.includes(app) || !app;
      setVisibility(state);
    }
    
    updateVisibility();
    window.addEventListener("popstate", updateVisibility);
    window.addEventListener("single-spa:routing-event", updateVisibility);
    
    return () => {
      window.removeEventListener("popstate", updateVisibility);
      window.removeEventListener("single-spa:routing-event", updateVisibility);
    };
  }, []);

  return (
    <>
      {visibility && (
        <div className={`${APP_CLASS} ${WRAPPER_CLASS}`}>
          <Footer />
        </div>
      )}
    </>
  );
}
